<template>
    <div id="sixth-desktop" :style="bg">
        <h2 :class="theme==0?'text-theme-1':theme==1?'text-theme-2':theme==2?'text-theme-3':'text-theme-4'">Contact Me</h2>
         <h3 :class="theme==1?'h3-theme-2':'h3-theme-1'">Get in touch</h3>
         <div id="content">
            <div id="contact">
                <div class="contact-info">
                    <div class="contact-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="38" height="45" viewBox="0 0 38 45" fill="none" v-if="theme==0">
                            <path d="M14.0883 3.6274L14.0883 3.61697C14.0869 3.21919 13.9552 2.88452 13.6823 2.58964C13.4018 2.2866 13.071 2.11379 12.6736 2.05846L3.75964 0.817063C3.22185 0.742168 2.7761 0.857461 2.38733 1.15119C1.99858 1.44489 1.7659 1.84213 1.69098 2.37984L14.0883 3.6274ZM14.0883 3.6274L14.0888 3.63783M14.0883 3.6274L14.0888 3.63783M14.0888 3.63783L14.4462 11.5298C14.4468 12.0011 14.379 12.4036 14.2529 12.7449C14.1373 13.0582 13.936 13.3284 13.6319 13.5581L13.6319 13.5581M14.0888 3.63783L13.6319 13.5581M13.6319 13.5581L13.6278 13.5612M13.6319 13.5581L13.6278 13.5612M13.6278 13.5612L7.59452 18.218L7.29263 18.451M13.6278 13.5612L7.29263 18.451M7.29263 18.451L7.43751 18.8038M7.29263 18.451L7.43751 18.8038M7.43751 18.8038C8.62778 21.7019 10.2309 24.4834 12.2442 27.1481C14.2575 29.813 16.5566 32.1964 19.1408 34.2975L19.4449 34.5448M7.43751 18.8038L19.4449 34.5448M19.4449 34.5448L19.7577 34.3085M19.4449 34.5448L19.7577 34.3085M19.7577 34.3085L25.6503 29.8565C25.95 29.6301 26.3358 29.4692 26.8265 29.3896C27.3099 29.3111 27.7595 29.3344 28.1816 29.4525L35.5404 32.0436C35.5412 32.0439 35.542 32.0442 35.5428 32.0445C35.9406 32.19 36.2377 32.428 36.4524 32.7635C36.664 33.0941 36.741 33.4459 36.686 33.841L35.4446 42.755C35.3697 43.2928 35.137 43.69 34.7482 43.9838C34.3594 44.2775 33.9137 44.3928 33.3759 44.3179C28.7201 43.6695 24.3237 41.9997 20.1831 39.3021M19.7577 34.3085L20.1831 39.3021M20.1831 39.3021C16.0318 36.5976 12.4827 33.2949 9.53343 29.393M20.1831 39.3021L9.53343 29.393M9.53343 29.393C6.58422 25.4911 4.37701 21.1749 2.9113 16.4415M9.53343 29.393L2.9113 16.4415M2.9113 16.4415C1.44929 11.72 1.04424 7.03455 1.69096 2.38L2.9113 16.4415Z" stroke="#A3B18A"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="37" height="46" viewBox="0 0 37 46" fill="none" v-if="theme==1">
                            <path d="M32.5266 45.0546C27.7945 44.3956 23.3289 42.6982 19.1298 39.9625C14.9308 37.2268 11.3389 33.8846 8.35428 29.9359C5.36966 25.9872 3.13604 21.6189 1.6534 16.8308C0.170771 12.0428 -0.241877 7.28333 0.415462 2.55249C0.507417 1.89219 0.804144 1.3726 1.30564 0.993704C1.80714 0.614811 2.38804 0.471343 3.04834 0.563298L11.9623 1.80469C12.4759 1.87621 12.9114 2.10514 13.269 2.49148C13.6265 2.87783 13.8062 3.33289 13.808 3.85667L14.1659 11.7593C14.1677 12.2831 14.093 12.7499 13.9417 13.1596C13.7904 13.5693 13.5275 13.9156 13.1531 14.1985L7.11975 18.8553C8.29262 21.711 9.87365 24.4553 11.8628 27.0882C13.852 29.7211 16.1231 32.0753 18.676 34.151L24.5686 29.699C24.9447 29.4149 25.4106 29.2277 25.9661 29.1375C26.5216 29.0474 27.0504 29.0739 27.5525 29.2171L34.9313 31.8153C35.4296 31.9968 35.8169 32.3036 36.0933 32.7354C36.3697 33.1673 36.4722 33.6393 36.4009 34.1514L35.1595 43.0654C35.0676 43.7257 34.7708 44.2453 34.2693 44.6242C33.7678 45.0031 33.1869 45.1465 32.5266 45.0546Z" fill="#344E41"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="38" height="45" viewBox="0 0 38 45" fill="none" v-if="theme==2 || theme==3">
                            <path d="M33.3069 44.8131C28.5748 44.1541 24.1092 42.4568 19.9101 39.721C15.711 36.9853 12.1192 33.6431 9.13455 29.6945C6.14994 25.7458 3.91631 21.3774 2.43368 16.5894C0.951044 11.8013 0.538397 7.04188 1.19574 2.31103C1.28769 1.65074 1.58442 1.13114 2.08592 0.752249C2.58742 0.373356 3.16831 0.229887 3.82861 0.321842L12.7426 1.56323C13.2561 1.63476 13.6917 1.86369 14.0492 2.25003C14.4068 2.63637 14.5865 3.09143 14.5883 3.61521L14.9461 11.5179C14.948 12.0417 14.8733 12.5084 14.722 12.9181C14.5707 13.3278 14.3078 13.6741 13.9333 13.9571L7.90002 18.6138C9.07289 21.4696 10.6539 24.2139 12.6431 26.8467C14.6323 29.4796 16.9033 31.8339 19.4563 33.9096L25.3489 29.4576C25.725 29.1734 26.1908 28.9862 26.7464 28.8961C27.3019 28.8059 27.8307 28.8324 28.3328 28.9756L35.7116 31.5738C36.2098 31.7554 36.5971 32.0621 36.8735 32.494C37.15 32.9259 37.2525 33.3979 37.1812 33.91L35.9398 42.8239C35.8478 43.4842 35.5511 44.0038 35.0496 44.3827C34.5481 44.7616 33.9672 44.9051 33.3069 44.8131Z" fill="#D4ADFC"/>
                          </svg>
                    </div>
                    <div class="contact-detail">
                        <h2 :class="theme==1?'contact-h2-2':'contact-h2-1'">Call Me</h2>
                        <h3 :class="theme==1?'contact-h3-2':'contact-h3-1'">+917895724996</h3>
                    </div>
                </div>
                <div class="contact-info">
                    <div class="contact-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="35" viewBox="0 0 41 35" fill="none" v-if="theme==0">
                            <path d="M41 4.375C41 1.96875 39.155 0 36.9 0H4.1C1.845 0 0 1.96875 0 4.375V30.625C0 33.0313 1.845 35 4.1 35H36.9C39.155 35 41 33.0313 41 30.625V4.375ZM36.9 4.375L20.5 15.2906L4.1 4.375H36.9ZM36.9 30.625H4.1V8.75L20.5 19.6875L36.9 8.75V30.625Z" fill="#A3B18A"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="41" height="35" viewBox="0 0 41 35" fill="none" v-if="theme==1">
                            <path d="M41 4.375C41 1.96875 39.155 0 36.9 0H4.1C1.845 0 0 1.96875 0 4.375V30.625C0 33.0313 1.845 35 4.1 35H36.9C39.155 35 41 33.0313 41 30.625V4.375ZM36.9 4.375L20.5 15.2906L4.1 4.375H36.9ZM36.9 30.625H4.1V8.75L20.5 19.6875L36.9 8.75V30.625Z" fill="#344E41"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="42" height="36" viewBox="0 0 42 36" fill="none" v-if="theme==2 || theme==3">
                            <path d="M41.7803 5.13355C41.7803 2.72729 39.9353 0.758545 37.6803 0.758545H4.88027C2.62527 0.758545 0.780273 2.72729 0.780273 5.13355V31.3835C0.780273 33.7898 2.62527 35.7585 4.88027 35.7585H37.6803C39.9353 35.7585 41.7803 33.7898 41.7803 31.3835V5.13355ZM37.6803 5.13355L21.2803 16.0492L4.88027 5.13355H37.6803ZM37.6803 31.3835H4.88027V9.50855L21.2803 20.446L37.6803 9.50855V31.3835Z" fill="#D4ADFC"/>
                          </svg>
                    </div>
                    <div class="contact-detail">
                        <h2 :class="theme==1?'contact-h2-2':'contact-h2-1'">Email</h2>
                        <h3 :class="theme==1?'contact-h3-2':'contact-h3-1'">dumkaabhipray@gmail.com</h3>
                    </div>
                </div>
                <div class="contact-info">
                    <div class="contact-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" v-if="theme==0">
                            <path d="M23.8533 38.739C29.6633 34.3514 40 25.3874 40 17.1614C40 12.6099 37.8929 8.24485 34.1421 5.02646C30.3914 1.80807 25.3043 0 20 0C14.6957 0 9.60859 1.80807 5.85786 5.02646C2.10714 8.24485 7.90407e-08 12.6099 0 17.1614C0 25.3874 10.3333 34.3514 16.1467 38.739C17.207 39.5511 18.5787 40 20 40C21.4213 40 22.793 39.5511 23.8533 38.739ZM13.3333 17.1614C13.3333 15.6442 14.0357 14.1892 15.286 13.1164C16.5362 12.0436 18.2319 11.4409 20 11.4409C21.7681 11.4409 23.4638 12.0436 24.714 13.1164C25.9643 14.1892 26.6667 15.6442 26.6667 17.1614C26.6667 18.6786 25.9643 20.1336 24.714 21.2064C23.4638 22.2792 21.7681 22.8819 20 22.8819C18.2319 22.8819 16.5362 22.2792 15.286 21.2064C14.0357 20.1336 13.3333 18.6786 13.3333 17.1614Z" fill="#A3B18A"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none" v-if="theme==1">
                            <path d="M23.8533 38.739C29.6633 34.3514 40 25.3874 40 17.1614C40 12.6099 37.8929 8.24485 34.1421 5.02646C30.3914 1.80807 25.3043 0 20 0C14.6957 0 9.60859 1.80807 5.85786 5.02646C2.10714 8.24485 7.90407e-08 12.6099 0 17.1614C0 25.3874 10.3333 34.3514 16.1467 38.739C17.207 39.5511 18.5787 40 20 40C21.4213 40 22.793 39.5511 23.8533 38.739ZM13.3333 17.1614C13.3333 15.6442 14.0357 14.1892 15.286 13.1164C16.5362 12.0436 18.2319 11.4409 20 11.4409C21.7681 11.4409 23.4638 12.0436 24.714 13.1164C25.9643 14.1892 26.6667 15.6442 26.6667 17.1614C26.6667 18.6786 25.9643 20.1336 24.714 21.2064C23.4638 22.2792 21.7681 22.8819 20 22.8819C18.2319 22.8819 16.5362 22.2792 15.286 21.2064C14.0357 20.1336 13.3333 18.6786 13.3333 17.1614Z" fill="#344E41"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" width="41" height="41" viewBox="0 0 41 41" fill="none" v-if="theme==2 || theme==3">
                            <path d="M24.6336 39.4976C30.4436 35.11 40.7803 26.146 40.7803 17.9199C40.7803 13.3685 38.6731 9.00339 34.9224 5.785C31.1717 2.56662 26.0846 0.758545 20.7803 0.758545C15.4759 0.758545 10.3889 2.56662 6.63814 5.785C2.88741 9.00339 0.780274 13.3685 0.780273 17.9199C0.780273 26.146 11.1136 35.11 16.9269 39.4976C17.9873 40.3097 19.3589 40.7585 20.7803 40.7585C22.2016 40.7585 23.5732 40.3097 24.6336 39.4976ZM14.1136 17.9199C14.1136 16.4028 14.816 14.9478 16.0662 13.875C17.3165 12.8022 19.0122 12.1995 20.7803 12.1995C22.5484 12.1995 24.2441 12.8022 25.4943 13.875C26.7446 14.9478 27.4469 16.4028 27.4469 17.9199C27.4469 19.4371 26.7446 20.8921 25.4943 21.9649C24.2441 23.0377 22.5484 23.6404 20.7803 23.6404C19.0122 23.6404 17.3165 23.0377 16.0662 21.9649C14.816 20.8921 14.1136 19.4371 14.1136 17.9199Z" fill="#D4ADFC"/>
                          </svg>
                    </div>
                    <div class="contact-detail">
                        <h2 :class="theme==1?'contact-h2-2':'contact-h2-1'">Location</h2>
                        <h3 :class="theme==1?'contact-h3-2':'contact-h3-1'">Haldwani,Uttrakhand,India</h3>
                    </div>
                </div>
             </div>
             <div :class="theme==1?'divider-2':'divider-1'"></div>
            <div>
                <div id="form">
                    <input type="text" placeholder="Name" :class="theme==0?'contact-input-1':theme==1?'contact-input-2':'contact-input-3'" v-model="name">
                    <input type="text" placeholder="Email" :class="theme==0?'contact-input-1':theme==1?'contact-input-2':'contact-input-3'" v-model="email">
                    <input type="text" placeholder="Contact" :class="theme==0?'contact-input-1':theme==1?'contact-input-2':'contact-input-3'" v-model="project">
                    <textarea id="text-area" cols="41" rows="5" :class="theme==0?'contact-text-area-1':theme==1?'contact-text-area-2':'contact-text-area-3'" v-model="Message" placeholder="message" style="resize:none"></textarea>
                  </div>
                  <div :class="theme==0?'pg-2-btn-1':theme==1?'pg-2-btn-2':theme==2?'pg-2-btn-3':'pg-2-btn-4'" @click="send">
                     <h3>Send Message</h3>
                     <svg xmlns="http://www.w3.org/2000/svg" width="44" height="37" viewBox="0 0 44 37" fill="none" v-if="theme==0">
                      <g filter="url(#filter0_d_13_94)">
                        <path d="M4.45542 0.245968C4.64748 0.114699 4.88316 0.0317638 5.13322 0.00745869C5.38327 -0.0168464 5.63668 0.0185496 5.86198 0.109252L39.2904 13.5737C39.5037 13.6599 39.683 13.7921 39.8083 13.9556C39.9336 14.1191 40 14.3075 40 14.4997C40 14.6919 39.9336 14.8803 39.8083 15.0438C39.683 15.2073 39.5037 15.3395 39.2904 15.4256L5.86198 28.8901C5.63684 28.9811 5.38349 29.0167 5.1334 28.9927C4.88331 28.9687 4.64749 28.886 4.45521 28.7549C4.26294 28.6239 4.12269 28.4502 4.05187 28.2555C3.98105 28.0608 3.98278 27.8536 4.05685 27.6597L9.08397 14.4997L4.05685 1.3397C3.98321 1.14597 3.98172 0.939097 4.05256 0.744691C4.1234 0.550286 4.26347 0.376888 4.45542 0.245968ZM11.3777 15.5354L7.39969 25.9549L35.8395 14.4997L7.39969 3.04451L11.3777 13.464H25.8573C26.1983 13.464 26.5253 13.5731 26.7664 13.7673C27.0076 13.9616 27.143 14.225 27.143 14.4997C27.143 14.7744 27.0076 15.0378 26.7664 15.2321C26.5253 15.4263 26.1983 15.5354 25.8573 15.5354H11.3777Z" fill="#344E41"/>
                      </g>
                      <defs>
                        <filter id="filter0_d_13_94" x="0" y="0" width="44" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                          <feOffset dy="4"/>
                          <feGaussianBlur stdDeviation="2"/>
                          <feComposite in2="hardAlpha" operator="out"/>
                          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13_94"/>
                          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13_94" result="shape"/>
                        </filter>
                      </defs>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="37" viewBox="0 0 44 37" fill="none" v-if='theme==1'>
                      <g filter="url(#filter0_d_17_151)">
                        <path d="M4.45542 0.245968C4.64748 0.114699 4.88316 0.0317638 5.13322 0.00745869C5.38327 -0.0168464 5.63668 0.0185496 5.86198 0.109252L39.2904 13.5737C39.5037 13.6599 39.683 13.7921 39.8083 13.9556C39.9336 14.1191 40 14.3075 40 14.4997C40 14.6919 39.9336 14.8803 39.8083 15.0438C39.683 15.2073 39.5037 15.3395 39.2904 15.4256L5.86198 28.8901C5.63684 28.9811 5.38349 29.0167 5.1334 28.9927C4.88331 28.9687 4.64749 28.886 4.45521 28.7549C4.26294 28.6239 4.12269 28.4502 4.05187 28.2555C3.98105 28.0608 3.98278 27.8536 4.05685 27.6597L9.08397 14.4997L4.05685 1.3397C3.98321 1.14597 3.98172 0.939097 4.05256 0.744691C4.1234 0.550286 4.26347 0.376888 4.45542 0.245968ZM11.3777 15.5354L7.39969 25.9549L35.8395 14.4997L7.39969 3.04451L11.3777 13.464H25.8573C26.1983 13.464 26.5253 13.5731 26.7664 13.7673C27.0076 13.9616 27.143 14.225 27.143 14.4997C27.143 14.7744 27.0076 15.0378 26.7664 15.2321C26.5253 15.4263 26.1983 15.5354 25.8573 15.5354H11.3777Z" fill="#A3B18A"/>
                      </g>
                      <defs>
                        <filter id="filter0_d_17_151" x="0" y="0" width="44" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                          <feOffset dy="4"/>
                          <feGaussianBlur stdDeviation="2"/>
                          <feComposite in2="hardAlpha" operator="out"/>
                          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17_151"/>
                          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17_151" result="shape"/>
                        </filter>
                      </defs>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="44" height="37" viewBox="0 0 44 37" fill="none" v-if="theme==2">
    <g filter="url(#filter0_d_227_92)">
      <path d="M4.45542 0.245968C4.64748 0.114699 4.88316 0.0317638 5.13322 0.00745869C5.38327 -0.0168464 5.63668 0.0185496 5.86198 0.109252L39.2904 13.5737C39.5037 13.6599 39.683 13.7921 39.8083 13.9556C39.9336 14.1191 40 14.3075 40 14.4997C40 14.6919 39.9336 14.8803 39.8083 15.0438C39.683 15.2073 39.5037 15.3395 39.2904 15.4256L5.86198 28.8901C5.63684 28.9811 5.38349 29.0167 5.1334 28.9927C4.88331 28.9687 4.64749 28.886 4.45521 28.7549C4.26294 28.6239 4.12269 28.4502 4.05187 28.2555C3.98105 28.0608 3.98278 27.8536 4.05685 27.6597L9.08397 14.4997L4.05685 1.3397C3.98321 1.14597 3.98172 0.939097 4.05256 0.744691C4.1234 0.550286 4.26347 0.376888 4.45542 0.245968ZM11.3777 15.5354L7.39969 25.9549L35.8395 14.4997L7.39969 3.04451L11.3777 13.464H25.8573C26.1983 13.464 26.5253 13.5731 26.7664 13.7673C27.0076 13.9616 27.143 14.225 27.143 14.4997C27.143 14.7744 27.0076 15.0378 26.7664 15.2321C26.5253 15.4263 26.1983 15.5354 25.8573 15.5354H11.3777Z" fill="#1D267D"/>
    </g>
    <defs>
      <filter id="filter0_d_227_92" x="0" y="0" width="44" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_227_92"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_227_92" result="shape"/>
      </filter>
    </defs>
                     </svg>
                     <svg xmlns="http://www.w3.org/2000/svg" width="44" height="37" viewBox="0 0 44 37" fill="none" v-if="theme==3">
    <g filter="url(#filter0_d_227_91)">
      <path d="M4.45542 0.245968C4.64748 0.114699 4.88316 0.0317638 5.13322 0.00745869C5.38327 -0.0168464 5.63668 0.0185496 5.86198 0.109252L39.2904 13.5737C39.5037 13.6599 39.683 13.7921 39.8083 13.9556C39.9336 14.1191 40 14.3075 40 14.4997C40 14.6919 39.9336 14.8803 39.8083 15.0438C39.683 15.2073 39.5037 15.3395 39.2904 15.4256L5.86198 28.8901C5.63684 28.9811 5.38349 29.0167 5.1334 28.9927C4.88331 28.9687 4.64749 28.886 4.45521 28.7549C4.26294 28.6239 4.12269 28.4502 4.05187 28.2555C3.98105 28.0608 3.98278 27.8536 4.05685 27.6597L9.08397 14.4997L4.05685 1.3397C3.98321 1.14597 3.98172 0.939097 4.05256 0.744691C4.1234 0.550286 4.26347 0.376888 4.45542 0.245968ZM11.3777 15.5354L7.39969 25.9549L35.8395 14.4997L7.39969 3.04451L11.3777 13.464H25.8573C26.1983 13.464 26.5253 13.5731 26.7664 13.7673C27.0076 13.9616 27.143 14.225 27.143 14.4997C27.143 14.7744 27.0076 15.0378 26.7664 15.2321C26.5253 15.4263 26.1983 15.5354 25.8573 15.5354H11.3777Z" fill="#0C134F"/>
    </g>
    <defs>
      <filter id="filter0_d_227_91" x="0" y="0" width="44" height="37" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="4"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_227_91"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_227_91" result="shape"/>
      </filter>
    </defs>
                       </svg>
         </div>
            </div>
         </div>
         <div :class="theme==0?'sixth-footer-1':theme==1?'sixth-footer-2':theme==2?'sixth-footer-3':'sixth-footer-4'">
            <div style="margin-top:-12px">
                <h2 :class="theme==0?'signature-1':theme==1?'signature-2':'signature-3'">Abhipray Dumka</h2>
                <h3 :class="theme==0?'sig-1':theme==1?'sig-2':'sig-3'">Software Developer</h3>
            </div>
            <div class="links2">
                <h3 :class="theme==0?'lk-1':theme==1?'lk-2':'lk-3'" @click="$emit('go-to','fourth-page')">Services</h3>
                <h3 :class="theme==0?'lk-1':theme==1?'lk-2':'lk-3'" @click="$emit('go-to','fifth-page')">Portfolio</h3>
                <h3 :class="theme==0?'lk-1':theme==1?'lk-2':'lk-3'" @click="$emit('go-to','sixth-page')">Contact Me</h3>
            </div>
            <div class="links1">
                <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35" fill="none" v-if="theme==1" @click="goto('https://www.instagram.com/abhipra_dumka/')">
                    <g filter="url(#filter0_d_2_1290)">
                      <path d="M17 9.45C15.9657 9.45 14.9737 9.87669 14.2423 10.6362C13.5109 11.3957 13.1 12.4259 13.1 13.5C13.1 14.5741 13.5109 15.6043 14.2423 16.3638C14.9737 17.1233 15.9657 17.55 17 17.55C18.0343 17.55 19.0263 17.1233 19.7577 16.3638C20.4891 15.6043 20.9 14.5741 20.9 13.5C20.9 12.4259 20.4891 11.3957 19.7577 10.6362C19.0263 9.87669 18.0343 9.45 17 9.45ZM17 6.75C18.7239 6.75 20.3772 7.46116 21.5962 8.72703C22.8152 9.9929 23.5 11.7098 23.5 13.5C23.5 15.2902 22.8152 17.0071 21.5962 18.273C20.3772 19.5388 18.7239 20.25 17 20.25C15.2761 20.25 13.6228 19.5388 12.4038 18.273C11.1848 17.0071 10.5 15.2902 10.5 13.5C10.5 11.7098 11.1848 9.9929 12.4038 8.72703C13.6228 7.46116 15.2761 6.75 17 6.75ZM25.45 6.4125C25.45 6.86005 25.2788 7.28928 24.974 7.60574C24.6693 7.92221 24.256 8.1 23.825 8.1C23.394 8.1 22.9807 7.92221 22.676 7.60574C22.3712 7.28928 22.2 6.86005 22.2 6.4125C22.2 5.96495 22.3712 5.53573 22.676 5.21926C22.9807 4.90279 23.394 4.725 23.825 4.725C24.256 4.725 24.6693 4.90279 24.974 5.21926C25.2788 5.53573 25.45 5.96495 25.45 6.4125ZM17 2.7C13.7838 2.7 13.2586 2.70945 11.7623 2.7783C10.7431 2.82825 10.0593 2.97 9.4249 3.2265C8.894 3.42892 8.41404 3.75335 8.0209 4.17555C7.61401 4.58379 7.30116 5.08219 7.1057 5.63355C6.8587 6.29505 6.7222 7.0038 6.6754 8.06085C6.6078 9.55125 6.5987 10.0724 6.5987 13.5C6.5987 16.8412 6.6078 17.3853 6.6741 18.9391C6.7222 19.9962 6.8587 20.7077 7.1044 21.3651C7.3254 21.9524 7.5854 22.3749 8.017 22.8231C8.4551 23.2767 8.862 23.548 9.421 23.7722C10.0632 24.03 10.747 24.1731 11.761 24.2217C13.1962 24.2919 13.698 24.3 16.9987 24.3C20.2162 24.3 20.7401 24.2906 22.2364 24.2217C23.253 24.1717 23.9368 24.03 24.5725 23.7749C25.1029 23.5714 25.5827 23.2471 25.9765 22.8258C26.4146 22.3722 26.6759 21.9496 26.8917 21.3678C27.1387 20.7036 27.2765 19.9935 27.3233 18.9378C27.3909 17.4487 27.3987 16.9263 27.3987 13.5C27.3987 10.1601 27.3896 9.6147 27.3233 8.06085C27.2752 7.00515 27.1374 6.29235 26.8917 5.63355C26.6957 5.08277 26.3835 4.58458 25.9778 4.17555C25.5849 3.75279 25.1049 3.42788 24.5738 3.22515C23.9368 2.96865 23.253 2.8269 22.2364 2.7783C20.8025 2.7081 20.302 2.7 17 2.7ZM17 0C20.5321 0 20.9728 0.0134999 22.3599 0.0809999C23.7431 0.1485 24.6869 0.37395 25.515 0.70875C26.373 1.05165 27.0958 1.51605 27.8186 2.2653C28.4796 2.94016 28.9911 3.75649 29.3175 4.6575C29.6386 5.51745 29.857 6.49755 29.922 7.9353C29.9831 9.3744 30 9.83205 30 13.5C30 17.1679 29.987 17.6256 29.922 19.0647C29.857 20.5025 29.6386 21.4812 29.3175 22.3425C28.992 23.244 28.4804 24.0605 27.8186 24.7347C27.1686 25.4209 26.3825 25.9521 25.515 26.2913C24.6869 26.6247 23.7431 26.8515 22.3599 26.919C20.9728 26.9825 20.5321 27 17 27C13.4679 27 13.0272 26.9865 11.6401 26.919C10.2569 26.8515 9.3144 26.6247 8.485 26.2913C7.61702 25.953 6.83079 25.4218 6.1814 24.7347C5.52026 24.0599 5.00875 23.2436 4.6825 22.3425C4.3601 21.4825 4.143 20.5025 4.078 19.0647C4.0156 17.6256 4 17.1679 4 13.5C4 9.83205 4.013 9.3744 4.078 7.9353C4.143 6.4962 4.3601 5.5188 4.6825 4.6575C5.00781 3.75594 5.51944 2.93938 6.1814 2.2653C6.83097 1.57846 7.61716 1.04723 8.485 0.70875C9.3131 0.37395 10.2556 0.1485 11.6401 0.0809999C13.0272 0.0175499 13.4679 0 17 0Z" fill="#DAD7CD"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_2_1290" x="0" y="0" width="34" height="35" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1290"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1290" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="35" viewBox="0 0 34 35" fill="none" v-if="theme==0" @click="goto('https://www.instagram.com/abhipra_dumka/')">
                    <g filter="url(#filter0_d_2_1930)">
                      <path d="M17 9.45C15.9657 9.45 14.9737 9.87669 14.2423 10.6362C13.5109 11.3957 13.1 12.4259 13.1 13.5C13.1 14.5741 13.5109 15.6043 14.2423 16.3638C14.9737 17.1233 15.9657 17.55 17 17.55C18.0343 17.55 19.0263 17.1233 19.7577 16.3638C20.4891 15.6043 20.9 14.5741 20.9 13.5C20.9 12.4259 20.4891 11.3957 19.7577 10.6362C19.0263 9.87669 18.0343 9.45 17 9.45ZM17 6.75C18.7239 6.75 20.3772 7.46116 21.5962 8.72703C22.8152 9.9929 23.5 11.7098 23.5 13.5C23.5 15.2902 22.8152 17.0071 21.5962 18.273C20.3772 19.5388 18.7239 20.25 17 20.25C15.2761 20.25 13.6228 19.5388 12.4038 18.273C11.1848 17.0071 10.5 15.2902 10.5 13.5C10.5 11.7098 11.1848 9.9929 12.4038 8.72703C13.6228 7.46116 15.2761 6.75 17 6.75ZM25.45 6.4125C25.45 6.86005 25.2788 7.28928 24.974 7.60574C24.6693 7.92221 24.256 8.1 23.825 8.1C23.394 8.1 22.9807 7.92221 22.676 7.60574C22.3712 7.28928 22.2 6.86005 22.2 6.4125C22.2 5.96495 22.3712 5.53573 22.676 5.21926C22.9807 4.90279 23.394 4.725 23.825 4.725C24.256 4.725 24.6693 4.90279 24.974 5.21926C25.2788 5.53573 25.45 5.96495 25.45 6.4125ZM17 2.7C13.7838 2.7 13.2586 2.70945 11.7623 2.7783C10.7431 2.82825 10.0593 2.97 9.4249 3.2265C8.894 3.42892 8.41404 3.75335 8.0209 4.17555C7.61401 4.58379 7.30116 5.08219 7.1057 5.63355C6.8587 6.29505 6.7222 7.0038 6.6754 8.06085C6.6078 9.55125 6.5987 10.0724 6.5987 13.5C6.5987 16.8412 6.6078 17.3853 6.6741 18.9391C6.7222 19.9962 6.8587 20.7077 7.1044 21.3651C7.3254 21.9524 7.5854 22.3749 8.017 22.8231C8.4551 23.2767 8.862 23.548 9.421 23.7722C10.0632 24.03 10.747 24.1731 11.761 24.2217C13.1962 24.2919 13.698 24.3 16.9987 24.3C20.2162 24.3 20.7401 24.2906 22.2364 24.2217C23.253 24.1717 23.9368 24.03 24.5725 23.7749C25.1029 23.5714 25.5827 23.2471 25.9765 22.8258C26.4146 22.3722 26.6759 21.9496 26.8917 21.3678C27.1387 20.7036 27.2765 19.9935 27.3233 18.9378C27.3909 17.4487 27.3987 16.9263 27.3987 13.5C27.3987 10.1601 27.3896 9.6147 27.3233 8.06085C27.2752 7.00515 27.1374 6.29235 26.8917 5.63355C26.6957 5.08277 26.3835 4.58458 25.9778 4.17555C25.5849 3.75279 25.1049 3.42788 24.5738 3.22515C23.9368 2.96865 23.253 2.8269 22.2364 2.7783C20.8025 2.7081 20.302 2.7 17 2.7ZM17 0C20.5321 0 20.9728 0.0134999 22.3599 0.0809999C23.7431 0.1485 24.6869 0.37395 25.515 0.70875C26.373 1.05165 27.0958 1.51605 27.8186 2.2653C28.4796 2.94016 28.9911 3.75649 29.3175 4.6575C29.6386 5.51745 29.857 6.49755 29.922 7.9353C29.9831 9.3744 30 9.83205 30 13.5C30 17.1679 29.987 17.6256 29.922 19.0647C29.857 20.5025 29.6386 21.4812 29.3175 22.3425C28.992 23.244 28.4804 24.0605 27.8186 24.7347C27.1686 25.4209 26.3825 25.9521 25.515 26.2913C24.6869 26.6247 23.7431 26.8515 22.3599 26.919C20.9728 26.9825 20.5321 27 17 27C13.4679 27 13.0272 26.9865 11.6401 26.919C10.2569 26.8515 9.3144 26.6247 8.485 26.2913C7.61702 25.953 6.83079 25.4218 6.1814 24.7347C5.52026 24.0599 5.00875 23.2436 4.6825 22.3425C4.3601 21.4825 4.143 20.5025 4.078 19.0647C4.0156 17.6256 4 17.1679 4 13.5C4 9.83205 4.013 9.3744 4.078 7.9353C4.143 6.4962 4.3601 5.5188 4.6825 4.6575C5.00781 3.75594 5.51944 2.93938 6.1814 2.2653C6.83097 1.57846 7.61716 1.04723 8.485 0.70875C9.3131 0.37395 10.2556 0.1485 11.6401 0.0809999C13.0272 0.0175499 13.4679 0 17 0Z" fill="#588157"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_2_1930" x="0" y="0" width="34" height="35" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1930"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1930" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="43" viewBox="0 0 42 43" fill="none" v-if="theme==2||theme==3" @click="goto('https://www.instagram.com/abhipra_dumka/')">
                    <g filter="url(#filter0_d_239_943)">
                      <path d="M21 12.25C19.6474 12.25 18.3502 12.8031 17.3938 13.7877C16.4373 14.7723 15.9 16.1076 15.9 17.5C15.9 18.8924 16.4373 20.2277 17.3938 21.2123C18.3502 22.1969 19.6474 22.75 21 22.75C22.3526 22.75 23.6498 22.1969 24.6062 21.2123C25.5627 20.2277 26.1 18.8924 26.1 17.5C26.1 16.1076 25.5627 14.7723 24.6062 13.7877C23.6498 12.8031 22.3526 12.25 21 12.25ZM21 8.75C23.2543 8.75 25.4163 9.67187 27.0104 11.3128C28.6045 12.9538 29.5 15.1794 29.5 17.5C29.5 19.8206 28.6045 22.0462 27.0104 23.6872C25.4163 25.3281 23.2543 26.25 21 26.25C18.7457 26.25 16.5837 25.3281 14.9896 23.6872C13.3955 22.0462 12.5 19.8206 12.5 17.5C12.5 15.1794 13.3955 12.9538 14.9896 11.3128C16.5837 9.67187 18.7457 8.75 21 8.75ZM32.05 8.3125C32.05 8.89266 31.8261 9.44906 31.4276 9.8593C31.0291 10.2695 30.4886 10.5 29.925 10.5C29.3614 10.5 28.8209 10.2695 28.4224 9.8593C28.0239 9.44906 27.8 8.89266 27.8 8.3125C27.8 7.73234 28.0239 7.17594 28.4224 6.7657C28.8209 6.35547 29.3614 6.125 29.925 6.125C30.4886 6.125 31.0291 6.35547 31.4276 6.7657C31.8261 7.17594 32.05 7.73234 32.05 8.3125ZM21 3.5C16.7942 3.5 16.1074 3.51225 14.1507 3.6015C12.8179 3.66625 11.9237 3.85 11.0941 4.1825C10.3998 4.44489 9.7722 4.86546 9.2581 5.41275C8.72601 5.94195 8.3169 6.58802 8.0613 7.30275C7.7383 8.16025 7.5598 9.079 7.4986 10.4493C7.4102 12.3813 7.3983 13.0567 7.3983 17.5C7.3983 21.8312 7.4102 22.5365 7.4969 24.5507C7.5598 25.921 7.7383 26.8433 8.0596 27.6955C8.3486 28.4568 8.6886 29.0045 9.253 29.5855C9.8259 30.1735 10.358 30.5252 11.089 30.8157C11.9288 31.15 12.823 31.3355 14.149 31.3985C16.0258 31.4895 16.682 31.5 20.9983 31.5C25.2058 31.5 25.8909 31.4877 27.8476 31.3985C29.177 31.3337 30.0712 31.15 30.9025 30.8193C31.5961 30.5556 32.2235 30.1352 32.7385 29.589C33.3114 29.001 33.6531 28.4532 33.9353 27.699C34.2583 26.838 34.4385 25.9175 34.4997 24.549C34.5881 22.6187 34.5983 21.9415 34.5983 17.5C34.5983 13.1705 34.5864 12.4635 34.4997 10.4493C34.4368 9.08075 34.2566 8.15675 33.9353 7.30275C33.679 6.58878 33.2707 5.94297 32.7402 5.41275C32.2263 4.86473 31.5987 4.44354 30.9042 4.18075C30.0712 3.84825 29.177 3.6645 27.8476 3.6015C25.9725 3.5105 25.318 3.5 21 3.5ZM21 0C25.6189 0 26.1952 0.0174999 28.0091 0.105C29.8179 0.1925 31.0521 0.48475 32.135 0.91875C33.257 1.36325 34.2022 1.96525 35.1474 2.9365C36.0118 3.81132 36.6807 4.86953 37.1075 6.0375C37.5274 7.15225 37.813 8.42275 37.898 10.2865C37.9779 12.152 38 12.7452 38 17.5C38 22.2548 37.983 22.848 37.898 24.7135C37.813 26.5772 37.5274 27.846 37.1075 28.9625C36.6819 30.1311 36.0129 31.1895 35.1474 32.0635C34.2973 32.9531 33.2694 33.6416 32.135 34.0813C31.0521 34.5135 29.8179 34.8075 28.0091 34.895C26.1952 34.9773 25.6189 35 21 35C16.3811 35 15.8048 34.9825 13.9909 34.895C12.1821 34.8075 10.9496 34.5135 9.865 34.0813C8.72996 33.6428 7.7018 32.9542 6.8526 32.0635C5.98803 31.1888 5.31913 30.1305 4.8925 28.9625C4.4709 27.8477 4.187 26.5772 4.102 24.7135C4.0204 22.848 4 22.2548 4 17.5C4 12.7452 4.017 12.152 4.102 10.2865C4.187 8.421 4.4709 7.154 4.8925 6.0375C5.3179 4.86881 5.98697 3.81031 6.8526 2.9365C7.70204 2.04615 8.73013 1.35753 9.865 0.91875C10.9479 0.48475 12.1804 0.1925 13.9909 0.105C15.8048 0.0227499 16.3811 0 21 0Z" fill="#1D267D"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_239_943" x="0" y="0" width="42" height="43" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_239_943"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_239_943" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="33" viewBox="0 0 36 33" fill="none" v-if="theme==1" @click="sendMail">
                    <g filter="url(#filter0_d_2_1291)">
                      <path d="M29.2 21.875H26.4V8.20312L18 14.0625L9.6 8.20312V21.875H6.8V3.125H8.48L18 9.76562L27.52 3.125H29.2M29.2 0H6.8C5.246 0 4 1.39062 4 3.125V21.875C4 22.7038 4.295 23.4987 4.8201 24.0847C5.3452 24.6708 6.05739 25 6.8 25H29.2C29.9426 25 30.6548 24.6708 31.1799 24.0847C31.705 23.4987 32 22.7038 32 21.875V3.125C32 2.2962 31.705 1.50134 31.1799 0.915291C30.6548 0.32924 29.9426 0 29.2 0Z" fill="#DAD7CD"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_2_1291" x="0" y="0" width="36" height="33" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1291"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1291" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="33" viewBox="0 0 36 33" fill="none" v-if="theme==0" @click="sendMail">
                    <g filter="url(#filter0_d_2_1931)">
                      <path d="M29.2 21.875H26.4V8.20312L18 14.0625L9.6 8.20312V21.875H6.8V3.125H8.48L18 9.76562L27.52 3.125H29.2M29.2 0H6.8C5.246 0 4 1.39062 4 3.125V21.875C4 22.7038 4.295 23.4987 4.8201 24.0847C5.3452 24.6708 6.05739 25 6.8 25H29.2C29.9426 25 30.6548 24.6708 31.1799 24.0847C31.705 23.4987 32 22.7038 32 21.875V3.125C32 2.2962 31.705 1.50134 31.1799 0.915291C30.6548 0.32924 29.9426 0 29.2 0Z" fill="#588157"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_2_1931" x="0" y="0" width="36" height="33" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1931"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1931" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="41" viewBox="0 0 44 41" fill="none" v-if="theme==2||theme==3" @click="sendMail">
                    <g filter="url(#filter0_d_239_944)">
                      <path d="M36.4 28.875H32.8V10.8281L22 18.5625L11.2 10.8281V28.875H7.6V4.125H9.76L22 12.8906L34.24 4.125H36.4M36.4 0H7.6C5.602 0 4 1.83563 4 4.125V28.875C4 29.969 4.37928 31.0182 5.05442 31.7918C5.72955 32.5654 6.64522 33 7.6 33H36.4C37.3548 33 38.2705 32.5654 38.9456 31.7918C39.6207 31.0182 40 29.969 40 28.875V4.125C40 3.03098 39.6207 1.98177 38.9456 1.20818C38.2705 0.434597 37.3548 0 36.4 0Z" fill="#1D267D"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_239_944" x="0" y="0" width="44" height="41" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_239_944"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_239_944" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none" v-if="theme==1" @click="goto('https://github.com/abhipray-cpu')">
                    <g filter="url(#filter0_d_2_1287)">
                      <path d="M25.7052 29V24.9874C25.7524 24.3207 25.6714 23.6505 25.4678 23.0213C25.2642 22.3921 24.9425 21.8184 24.5242 21.3383C28.4693 20.8489 32.6155 19.1851 32.6155 11.5514C32.6152 9.59935 31.9404 7.72218 30.7309 6.3084C31.3036 4.6006 31.2631 2.7129 30.6178 1.03746C30.6178 1.03746 29.1352 0.548116 25.7052 3.10669C22.8255 2.2382 19.79 2.2382 16.9104 3.10669C13.4804 0.548116 11.9978 1.03746 11.9978 1.03746C11.3525 2.7129 11.312 4.6006 11.8847 6.3084C10.6662 7.73267 9.9907 9.6268 10.0001 11.5933C10.0001 19.1712 14.1462 20.8349 18.0914 21.3802C17.678 21.8555 17.3592 22.4224 17.1557 23.0439C16.9523 23.6653 16.8686 24.3276 16.9104 24.9874V29" stroke="#DAD7CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13.7949 28.2037C10.0256 29.5641 6.88462 28.2037 5 24.0094" stroke="#DAD7CD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_2_1287" x="0.249756" y="0.25" width="37.1157" height="37.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1287"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1287" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none" v-if="theme==0" @click="goto('https://github.com/abhipray-cpu')">
                    <g filter="url(#filter0_d_2_1927)">
                      <path d="M25.7052 29V24.9874C25.7524 24.3207 25.6714 23.6505 25.4678 23.0213C25.2642 22.3921 24.9425 21.8184 24.5242 21.3383C28.4693 20.8489 32.6155 19.1851 32.6155 11.5514C32.6152 9.59935 31.9404 7.72218 30.7309 6.3084C31.3036 4.6006 31.2631 2.7129 30.6178 1.03746C30.6178 1.03746 29.1352 0.548116 25.7052 3.10669C22.8255 2.2382 19.79 2.2382 16.9104 3.10669C13.4804 0.548116 11.9978 1.03746 11.9978 1.03746C11.3525 2.7129 11.312 4.6006 11.8847 6.3084C10.6662 7.73267 9.9907 9.6268 10.0001 11.5933C10.0001 19.1712 14.1462 20.8349 18.0914 21.3802C17.678 21.8555 17.3592 22.4224 17.1557 23.0439C16.9523 23.6653 16.8686 24.3276 16.9104 24.9874V29" stroke="#588157" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M13.7949 28.2037C10.0256 29.5641 6.88462 28.2037 5 24.0093" stroke="#588157" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_2_1927" x="0.249756" y="0.25" width="37.1157" height="37.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2_1927"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2_1927" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" v-if="theme==2||theme==3" @click="goto('https://github.com/abhipray-cpu')">
                    <g filter="url(#filter0_d_239_940)">
                      <path d="M33.4912 39V33.5543C33.556 32.6495 33.4446 31.74 33.1644 30.8861C32.8842 30.0322 32.4416 29.2536 31.866 28.6019C37.2947 27.9378 43.0001 25.6798 43.0001 15.3197C42.9996 12.6705 42.0711 10.123 40.4067 8.20425C41.1949 5.88652 41.1391 3.32466 40.2511 1.05084C40.2511 1.05084 38.211 0.386729 33.4912 3.85908C29.5286 2.68042 25.3515 2.68042 21.3889 3.85908C16.669 0.386729 14.629 1.05084 14.629 1.05084C13.741 3.32466 13.6852 5.88652 14.4734 8.20425C12.7965 10.1372 11.8671 12.7078 11.88 15.3766C11.88 25.6609 17.5854 27.9188 23.0141 28.6589C22.4453 29.3039 22.0066 30.0732 21.7266 30.9167C21.4466 31.7601 21.3315 32.6588 21.3889 33.5543V39" fill="#1D267D"/>
                      <path d="M33.4912 39V33.5543C33.556 32.6495 33.4446 31.74 33.1644 30.8861C32.8842 30.0322 32.4416 29.2536 31.866 28.6019C37.2947 27.9378 43.0001 25.6798 43.0001 15.3197C42.9996 12.6705 42.0711 10.123 40.4067 8.20425C41.1949 5.88652 41.1391 3.32466 40.2511 1.05084C40.2511 1.05084 38.211 0.386729 33.4912 3.85908C29.5286 2.68042 25.3515 2.68042 21.3889 3.85908C16.669 0.386729 14.629 1.05084 14.629 1.05084C13.741 3.32466 13.6852 5.88652 14.4734 8.20425C12.7965 10.1372 11.8671 12.7078 11.88 15.3766C11.88 25.6609 17.5854 27.9188 23.0141 28.6589C22.4453 29.3039 22.0066 30.0732 21.7266 30.9167C21.4466 31.7601 21.3315 32.6588 21.3889 33.5543V39" stroke="#0C134F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M17.1022 37.9192C11.9156 39.7654 7.59334 37.9192 5 32.2268Z" fill="#1D267D"/>
                      <path d="M17.1022 37.9192C11.9156 39.7654 7.59334 37.9192 5 32.2268" stroke="#0C134F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_239_940" x="0.25" y="0.25" width="47.5" height="47.5" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_239_940"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_239_940" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" v-if="theme==0" @click="goto('https://dumkaabhipray.wixsite.com/avi-talks')">
                    <g filter="url(#filter0_d_253_10)">
                      <path d="M16.3257 12.4466C16.69 12.0746 16.7963 12.0594 19.0884 12.0594C21.1528 12.0594 21.2211 12.067 21.5247 12.2188C21.9649 12.439 22.1546 12.7502 22.1546 13.2512C22.1546 13.6991 21.9725 14.0104 21.5778 14.2685C21.3653 14.4051 21.2363 14.4127 19.2174 14.4279C17.9727 14.4355 16.9784 14.4127 16.8267 14.3671C16.0449 14.147 15.7565 13.0235 16.3257 12.4466ZM20.9858 19.6203C16.895 19.6203 16.7508 19.6354 16.4168 19.9315C16.1512 20.1668 15.9842 20.6451 16.0297 20.9867C16.0829 21.3435 16.394 21.7534 16.728 21.8976C16.895 21.9735 17.7981 22.0267 21.001 21.9887L24.6365 21.9432L25.3347 21.8293C26.0178 21.4421 26.1317 20.5084 25.57 19.977C25.1678 19.6203 25.1905 19.6203 20.9858 19.6203ZM37.9413 29.4964C37.6757 31.6523 36.1957 33.3224 34.0629 33.8613C33.5165 33.998 33.3267 34.0056 20.9403 33.998C8.96369 33.998 8.34892 33.9904 7.88594 33.8613C7.24841 33.6943 6.70195 33.4438 6.19343 33.1022C5.76841 32.8138 5.13846 32.2065 4.90318 31.8573C4.61477 31.4322 4.28082 30.6958 4.1442 30.1872C4.00759 29.6786 4 29.4736 4 17.0241C4 4.64281 4 4.37712 4.13662 3.83815C4.61477 1.96312 6.10236 0.528385 8.02256 0.103277C8.57661 -0.0181819 33.2281 -0.0409557 33.8277 0.0805035C35.4367 0.406925 36.7042 1.3786 37.4404 2.8437C38.0248 4.00515 37.9716 2.72983 37.9944 16.5534C38.0096 25.344 37.9944 29.0409 37.9413 29.4964ZM31.4597 15.4375C31.3762 15.0579 31.1409 14.7087 30.8752 14.5645C30.7918 14.519 30.2681 14.4658 29.6988 14.4355C28.7577 14.3899 28.6515 14.3747 28.3479 14.2001C27.8773 13.9269 27.7483 13.6232 27.7407 12.8109C27.7407 11.2623 27.0956 9.82001 25.8205 8.52192C24.9097 7.59579 23.9003 6.96572 22.7391 6.61653C22.4658 6.53302 21.8435 6.50266 19.7639 6.47989C16.5079 6.44193 15.7793 6.51025 14.6712 6.95054C12.6219 7.7628 11.1571 9.486 10.6182 11.6874C10.5196 12.0974 10.4968 12.7654 10.474 16.5686C10.4437 21.3359 10.474 22.0418 10.7776 22.9832C11.5138 25.3137 13.5934 27.0369 15.6806 27.4164C16.3789 27.5455 24.9553 27.5758 25.8281 27.4544C27.3536 27.2494 28.5528 26.6345 29.6761 25.4882C30.4882 24.6608 30.9967 23.7575 31.3306 22.5656C31.5735 21.7382 31.5507 15.855 31.4597 15.4375Z" fill="#588157"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_253_10" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_10"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_253_10" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" v-if="theme==1" @click="goto('https://dumkaabhipray.wixsite.com/avi-talks')">
                    <g filter="url(#filter0_d_253_9)">
                      <path d="M16.3257 12.4466C16.69 12.0746 16.7963 12.0594 19.0884 12.0594C21.1528 12.0594 21.2211 12.067 21.5247 12.2188C21.9649 12.439 22.1546 12.7502 22.1546 13.2512C22.1546 13.6991 21.9725 14.0104 21.5778 14.2685C21.3653 14.4051 21.2363 14.4127 19.2174 14.4279C17.9727 14.4355 16.9784 14.4127 16.8267 14.3671C16.0449 14.147 15.7565 13.0235 16.3257 12.4466ZM20.9858 19.6203C16.895 19.6203 16.7508 19.6354 16.4168 19.9315C16.1512 20.1668 15.9842 20.6451 16.0297 20.9867C16.0829 21.3435 16.394 21.7534 16.728 21.8976C16.895 21.9735 17.7981 22.0267 21.001 21.9887L24.6365 21.9432L25.3347 21.8293C26.0178 21.4421 26.1317 20.5084 25.57 19.977C25.1678 19.6203 25.1905 19.6203 20.9858 19.6203ZM37.9413 29.4964C37.6757 31.6523 36.1957 33.3224 34.0629 33.8613C33.5165 33.998 33.3267 34.0056 20.9403 33.998C8.96369 33.998 8.34892 33.9904 7.88594 33.8613C7.24841 33.6943 6.70195 33.4438 6.19343 33.1022C5.76841 32.8138 5.13846 32.2065 4.90318 31.8573C4.61477 31.4322 4.28082 30.6958 4.1442 30.1872C4.00759 29.6786 4 29.4736 4 17.0241C4 4.64281 4 4.37712 4.13662 3.83815C4.61477 1.96312 6.10236 0.528385 8.02256 0.103277C8.57661 -0.0181819 33.2281 -0.0409557 33.8277 0.0805035C35.4367 0.406925 36.7042 1.3786 37.4404 2.8437C38.0248 4.00515 37.9717 2.72983 37.9944 16.5534C38.0096 25.344 37.9944 29.0409 37.9413 29.4964ZM31.4597 15.4375C31.3762 15.0579 31.1409 14.7087 30.8752 14.5645C30.7918 14.519 30.2681 14.4658 29.6988 14.4355C28.7577 14.3899 28.6515 14.3747 28.3479 14.2001C27.8773 13.9269 27.7483 13.6232 27.7407 12.8109C27.7407 11.2623 27.0956 9.82001 25.8205 8.52192C24.9097 7.59579 23.9003 6.96572 22.7391 6.61653C22.4658 6.53302 21.8435 6.50266 19.7639 6.47989C16.5079 6.44193 15.7793 6.51025 14.6712 6.95054C12.6219 7.7628 11.1571 9.486 10.6182 11.6874C10.5196 12.0974 10.4968 12.7654 10.474 16.5686C10.4437 21.3359 10.474 22.0418 10.7776 22.9832C11.5138 25.3137 13.5934 27.0369 15.6806 27.4164C16.3789 27.5455 24.9553 27.5758 25.8281 27.4544C27.3536 27.2494 28.5528 26.6345 29.6761 25.4883C30.4882 24.6608 30.9967 23.7575 31.3306 22.5656C31.5735 21.7382 31.5507 15.855 31.4597 15.4375Z" fill="#DAD7CD"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_253_9" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_253_9"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_253_9" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
                  <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none" v-if="theme==2 || theme==3" @click="goto('https://dumkaabhipray.wixsite.com/avi-talks')">
                    <g filter="url(#filter0_d_256_2)">
                      <path d="M16.3257 12.4466C16.69 12.0746 16.7963 12.0594 19.0884 12.0594C21.1528 12.0594 21.2211 12.067 21.5247 12.2188C21.9649 12.439 22.1546 12.7502 22.1546 13.2512C22.1546 13.6991 21.9725 14.0104 21.5778 14.2685C21.3653 14.4051 21.2363 14.4127 19.2174 14.4279C17.9727 14.4355 16.9784 14.4127 16.8267 14.3671C16.0449 14.147 15.7565 13.0235 16.3257 12.4466ZM20.9858 19.6203C16.895 19.6203 16.7508 19.6354 16.4168 19.9315C16.1512 20.1668 15.9842 20.6451 16.0297 20.9867C16.0829 21.3435 16.394 21.7534 16.728 21.8976C16.895 21.9735 17.7981 22.0267 21.001 21.9887L24.6365 21.9432L25.3347 21.8293C26.0178 21.4421 26.1317 20.5084 25.57 19.977C25.1678 19.6203 25.1905 19.6203 20.9858 19.6203ZM37.9413 29.4964C37.6757 31.6523 36.1957 33.3224 34.0629 33.8613C33.5165 33.998 33.3267 34.0056 20.9403 33.998C8.96369 33.998 8.34892 33.9904 7.88594 33.8613C7.24841 33.6943 6.70195 33.4438 6.19343 33.1022C5.76841 32.8138 5.13846 32.2065 4.90318 31.8573C4.61477 31.4322 4.28082 30.6958 4.1442 30.1872C4.00759 29.6786 4 29.4736 4 17.0241C4 4.64281 4 4.37712 4.13662 3.83815C4.61477 1.96312 6.10236 0.528385 8.02256 0.103277C8.57661 -0.0181819 33.2281 -0.0409557 33.8277 0.0805035C35.4367 0.406925 36.7042 1.3786 37.4404 2.8437C38.0248 4.00515 37.9716 2.72983 37.9944 16.5534C38.0096 25.344 37.9944 29.0409 37.9413 29.4964ZM31.4597 15.4375C31.3762 15.0579 31.1409 14.7087 30.8752 14.5645C30.7918 14.519 30.2681 14.4658 29.6988 14.4355C28.7577 14.3899 28.6515 14.3747 28.3479 14.2001C27.8773 13.9269 27.7483 13.6232 27.7407 12.8109C27.7407 11.2623 27.0956 9.82001 25.8205 8.52192C24.9097 7.59579 23.9003 6.96572 22.7391 6.61653C22.4658 6.53302 21.8435 6.50266 19.7639 6.47989C16.5079 6.44193 15.7793 6.51025 14.6712 6.95054C12.6219 7.7628 11.1571 9.486 10.6182 11.6874C10.5196 12.0974 10.4968 12.7654 10.474 16.5686C10.4437 21.3359 10.474 22.0418 10.7776 22.9832C11.5138 25.3137 13.5934 27.0369 15.6806 27.4164C16.3789 27.5455 24.9553 27.5758 25.8281 27.4544C27.3536 27.2494 28.5528 26.6345 29.6761 25.4882C30.4882 24.6608 30.9967 23.7575 31.3306 22.5656C31.5735 21.7382 31.5507 15.855 31.4597 15.4375Z" fill="#1D267D"/>
                    </g>
                    <defs>
                      <filter id="filter0_d_256_2" x="0" y="0" width="42" height="42" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                        <feOffset dy="4"/>
                        <feGaussianBlur stdDeviation="2"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_256_2"/>
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_256_2" result="shape"/>
                      </filter>
                    </defs>
                  </svg>
            </div>
         </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            name:'',
            email:'',
            project:'',
            message:''
        }
    },
    computed:{
        bg(){
          let theme = this.$store.getters['getTheme']
            if(theme==0){
                return `background:#344E41`
            }
            else if(theme==1){
                return `background:#A3B18A`
            }
            else if(theme==2){
              return 'background:#0C134F'
            }
            else if(theme==3){
              return 'background:#1D267D'
            }
            else{
              return `background:#344E41`
            }
        },
        text(){
            let theme = this.$store.getters['getTheme']
            if(theme==0){
                return `color:#344E41`
            }
            else{
                return `color:`
            }
        },
        theme(){
            return this.$store.getters['getTheme']
        },
    },
    methods:{
        send(){
            //this function will send mail to me
        },
      goto(val){
        window.open(val, '_blank');

      },
      sendMail(){
        window.location.href = `mailto:dumkaabhipray@gmail.com`;
      }
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Ingrid+Darling&display=swap');
@media only screen and (min-width:961px){
    #sixth-desktop{
        width:100vw;
        position: relative;
        height:fit-content;
        overflow-x:hidden;
        overflow-y:auto;
        padding-top:4vh;
        margin-top:-0.3vh;
        }
        .text-theme-1{
            color: #A3B18A;
        font-family: Roboto;
        font-size: 48px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-align:center;
        margin-bottom:0px;
        }
        .text-theme-2{
            color: #344E41;
            font-family: Roboto;
            font-size: 48px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-align: center;
            margin-bottom:0px;
        }
        .text-theme-3{
          color: #5C469C;
          font-family: Roboto;
          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-align: center;
          margin-bottom:0px;
      }
      .text-theme-4{
          color: #D4ADFC;
          font-family: Roboto;
          font-size: 48px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
          text-align: center;
          margin-bottom:0px;
      }
        .h3-theme-1{
            color: #C8CFCC;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 350;
            line-height: normal;
            text-align: center;
            margin-top:2px;
        }
        .h3-theme-2{
            color: #588157;
        font-family: Roboto;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
            margin-top:2px;
            text-align: center;
        }
        #content{
            width:100vw;
            padding-left:6vw;
            display: grid;
            grid-template-columns: 39vw 2vw 39vw
        }
        #contact{
            width:39vw;
            padding:0;
        }
        .contact-info{
            width:39vw;
            display: grid;
            grid-template-columns:10vw 20vw;
            margin-left:5vw;
            margin-top:2vh;
            margin-bottom:2vh;
        }
        .contact-icon{
            margin-left:10vw;
            margin-top:6vh;
        }
       
        .contact-detail{
            padding-left:4vw;
        }
        .contact-h2-1{
            color: #DAD7CD;
            font-family: Roboto;
            font-size: 36px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-bottom:0px;
        }
        .contact-h2-2{
            color: #344E41;
            font-family: Roboto;
            font-size: 36px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-bottom:0px;
        }
        .contact-h3-1{
            color: #C8CFCC;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-top:3px;
        }
        .contact-h3-2{
            color: #588157;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-top:3px;
        }
        #form{
            width:39vw;
            margin-top:.75vh;
            margin-left:0vw;
        }
        input,
        input:focus,
        input::selection{
            outline:none;
            border:none;
        }
        .contact-input-1{
            position: relative;
            margin-top:1.5vh;
            margin-bottom:1.5vh;
            width:32vw;
            height:60px;
            border-radius: 5px;
            background: #DAD7CD;
            margin-left:5vw;
            padding-left:1vw;
            color: #344E41;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
        .contact-input-2{
            position: relative;
            margin-top:1.5vh;
            margin-bottom:1.5vh;
            width:32vw;
            height:60px;
            border-radius: 5px;
            background: #3A5A40;
            margin-left:5vw;
            padding-left:1vw;
            color: #DAD7CD;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
        .contact-input-3{
          position: relative;
          margin-top:1.5vh;
          margin-bottom:1.5vh;
          width:32vw;
          height:60px;
          border-radius: 5px;
          background: white;
          margin-left:5vw;
          padding-left:1vw;
          color: rgba(0, 0, 0, 0.862);
          font-family: Roboto;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
      }
        .contact-input-1::placeholder,
        .contact-text-area-1::placeholder{
            color: #344e41bf;
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
        }
        .contact-input-2::placeholder,
        .contact-text-area-2::placeholder{
            color: #dad7cdb0;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
        .contact-input-3::placeholder,
        .contact-text-area-3::placeholder{
          color: #0e0d0dac;
            font-family: Roboto;
            font-size: 24px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
        }
        
        textarea {
            border-style: none;
            border-color: Transparent;
            overflow: auto;
            outline: none;
          }
        .contact-text-area-1{
            margin-left:5vw;
            margin-top:1.5vw;
            border-radius: 5px;
            padding-left:1vw;
            padding-top:1vw;
    background: #DAD7CD;
    color: #344E41;
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
        }
        .contact-text-area-2{
            margin-left:5vw;
            margin-top:1.5vw;
            border-radius: 5px;
            padding-left:1vw;
            padding-top:1vw;
            border-radius: 5px;
    background: #3A5A40;
    padding-left:1vw;
    color: #DAD7CD;
    font-family: Roboto;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
        }
        .contact-text-area-3{
          margin-left:5vw;
          margin-top:1.5vw;
          border-radius: 5px;
          padding-left:1vw;
          padding-top:1vw;
          border-radius: 5px;
  background: white;
  color: rgba(0, 0, 0, 0.862);
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
      }
        .pg-2-btn-1{
            width:15vw;
            margin-left:5vw;
            margin-top:2vh;
            height:8vh;
            border-radius: 10px;
            box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
            background: #A3B18A;
            cursor: pointer;
        }
        .pg-2-btn-1 h3{
            color: #344E41;
        font-family: Inter;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: 8vh;
        margin-top:0px;
        margin-left:1vw;
        float:left
        }
        .pg-2-btn-1 svg,
        .pg-2-btn-2 svg,
        .pg-2-btn-3 svg,
        .pg-2-btn-4 svg{
            float:right;
            margin-top:2vh;
            margin-right:1vw;
        }
        .pg-2-btn-2{
            width:15vw;
            margin-left:5vw;
            margin-top:2vh;
            height:8vh;
            border-radius: 10px;
        background: #344E41;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        cursor: pointer;
        }
        .pg-2-btn-2 h3{
            color: #A3B18A;
        font-family: Inter;
        font-size: 20px;
        font-style: normal;
            font-weight: 600;
            line-height: 8vh;
            margin-top:0px;
            margin-left:1vw;
            float:left
        }
        .pg-2-btn-3{
          width:15vw;
          margin-left:5vw;
          margin-top:2vh;
          height:8vh;
          border-radius: 10px;
          background: #D4ADFC;
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
      cursor: pointer;
      }
      .pg-2-btn-3 h3{
        color: #1D267D;
      font-family: Inter;
      font-size: 20px;
      font-style: normal;
          font-weight: 600;
          line-height: 8vh;
          margin-top:0px;
          margin-left:1vw;
          float:left
      }
      .pg-2-btn-4{
        width:15vw;
        margin-left:5vw;
        margin-top:2vh;
        height:8vh;
        border-radius: 10px;
        background: #A2A1B5;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    cursor: pointer;
    }
    .pg-2-btn-4 h3{
      color: #1D267D;
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
        font-weight: 600;
        line-height: 8vh;
        margin-top:0px;
        margin-left:1vw;
        float:left
    }
        .divider-1{
           width:1px;
background: #A3B18A;
height:70vh;
margin-left:4vw;
        }
        .divider-2{
width: 1px;
background:#588157;
height:75vh;
margin-left:4vw;
        }
.sixth-footer-1{
    width:100vw;
    height:20vh;
    left:0;
    background:#A3B18A;
    padding-left:1vw;
    display: flex;
    flex-direction: row;
}
.sixth-footer-2{
    width:100vw;
    height:20vh;
    left:0;
    background:#344E41;
    padding-left:1vw;
    display: flex;
    flex-direction: row;
}
.sixth-footer-3{
  width:100vw;
  height:20vh;
  left:0;
  background: #D4ADFC;
  padding-left:1vw;
  display: flex;
  flex-direction: row;
}
.sixth-footer-4{
  width:100vw;
  height:20vh;
  left:0;
  background: #D4ADFC;
  padding-left:1vw;
  display: flex;
  flex-direction: row;
}
.signature-1{
    color: #344E41;
font-family: Ingrid Darling;
font-size: 48px;
font-style: normal;
font-weight: 400;
line-height: normal;
    margin-left:4vw;
    margin-bottom:0px;
}
.signature-2{
    color: #A3B18A;
    font-family: Ingrid Darling;
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
margin-left:4vw;
margin-bottom:0px;
}
.signature-2{
  color: #A3B18A;
  font-family: Ingrid Darling;
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
margin-left:4vw;
margin-bottom:0px;
}
.signature-3{
  color: #0C134F;
  font-family: Ingrid Darling;
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
margin-left:4vw;
margin-bottom:0px;
}

.sig-1{
    color: #3A5A40;
font-family: Roboto;
font-size: 32px;
font-style: normal;
font-weight: 400;
line-height: normal;
    margin-top:3px;
    margin-left:4vw;
    margin-bottom:0px;
}
.sig-2{
    color: #A3B18A;
font-family: Roboto;
font-size: 32px;
font-style: normal;
font-weight: 400;
line-height: normal;
    margin-top:3px;
    margin-left:4vw;
    margin-bottom:0px;
}
.sig-3{
  color: #5C469C;
font-family: Roboto;
font-size: 32px;
font-style: normal;
font-weight: 400;
line-height: normal;
  margin-top:3px;
  margin-left:4vw;
  margin-bottom:0px;
}
.links2{
    padding-left:8vw;
    padding-top:1vh;
}
.lk-1{
    color: #3A5A40;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
}
.lk-2{
    color: #DAD7CD;
    font-family: Roboto;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
}
.lk-3{
  color: #0C134F;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}
.links1{
    display: flex;
    flex-direction: row;
    padding-left:5vw;
    padding-top:10vh;
}
.links1 svg{
    margin-left:1.5vw;
    margin-right:1.5vw;
    cursor: pointer;
}
}
@media only screen and (max-width:480px){
    #sixth-desktop{
        display: none;
    }
}
@media only screen and (min-width:481px) and (max-width:961px){
  #sixth-desktop{
      display: none;
  }
}
</style>